/**
 * Created by jgolebiewski on 3.11.2015.
 */
auth.factory('remindResource', ['$resource', function ($resource) {
    return $resource('/password/new', {}, {
        send: {
            method: 'POST'
        }
    });
}]);